import { render, staticRenderFns } from "./IncidentForm.vue?vue&type=template&id=e64035ea"
import script from "./IncidentForm.vue?vue&type=script&lang=ts"
export * from "./IncidentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports